// Day-first UTC, the same way the document prints its own dates. A reader
// comparing page against paper must not have to reconcile two formats.
const pad = (value: number): string => String(value).padStart(2, "0");

const parse = (value: string | undefined): Date | null => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDocumentDate = (value: string | undefined): string => {
  const date = parse(value);
  if (!date) return "";

  return [
    pad(date.getUTCDate()),
    pad(date.getUTCMonth() + 1),
    date.getUTCFullYear(),
  ].join("/");
};

export const formatDocumentDateTime = (value: string | undefined): string => {
  const date = parse(value);
  if (!date) return "";

  return `${formatDocumentDate(value)} ${pad(date.getUTCHours())}:${pad(
    date.getUTCMinutes()
  )} UTC`;
};

// The retention promise this document was issued under, stated in the unit
// the copy uses, and read from the record rather than from a constant.
export const retentionMonths = (retentionDays: number | undefined): number =>
  Math.max(1, Math.round((retentionDays ?? 0) / 30));

export default formatDocumentDate;
